import { recentChatSocketReducerStateModel } from "../../models/model";
import { actionTypes } from '../action/action';
const initialState = {
  recentChatList: {},
  recentLoading: false,
  savedChatList: [],
  historyLoading: false,
  historyFailedmsg:[]
};
export const chatSocketRecentReducerState = (state: recentChatSocketReducerStateModel = initialState, action: any) => {

  switch (action.type) {

    case actionTypes.RECENT_MESSAGE_LIST:
      return {
        ...state, recentChatList: action.payload.recentChatList,
        recentLoading: action.payload.recentLoading
      };
      case actionTypes.RECENT_LOADING:
        return {
          ...state,
          recentLoading: action.payload.recentLoading
        };
    case actionTypes.RECENT_SAVECHAT:
      
      return {
        ...state, savedChatList: action.payload.savedChatList
      };
      case actionTypes.HISTORY_LOADING:
      
      return {
        ...state, historyLoading: action.payload.historyLoading,historyFailedmsg:action.payload.historyFailedmsg
      };  

      
    default:
      return state;
  }
};
